import React, { Component } from 'react';
import { Container, Form, Col, Button, Table, Modal, Navbar } from 'react-bootstrap';
import axios from 'axios'

import { AdminNav, RequestModal, Loading } from '../../helpers';
import { convertRiceTypeENToTH, convertRiceTypeTHToEN, addCommaInNumber, convertRiceTypeENToENFull,updateState,evalSurveyRequest,evalCheckWeight } from '../../helpers/function';
import { onPrint } from '../../helpers/functionForLicense';

import {
  exportExcelNew, exportExcelParboild, exportExcelMultipleNew, exportExcelMultipleParboild
} from '../../helpers/functionForStats'

function remove_double_spacing(s) {
  if (s != undefined) {
    return s?.replaceAll('  ', ' ').trim()
  } else {
    return ''
  }
}
function remove_go_down(s) {
  if (s != undefined) {
    return s?.replaceAll('godown', '')
  } else {
    return ''
  }
}
function modifier_license_length(s) {
  if (s != undefined) {
    return `${s?.slice(8, s.length)}`
  } else {
    return ''
  }
}
function modifier_loading(s) {
  if (s == 'Container NO') {
    return '/'
  } else {
    return ''
  }
}
function modifier_vehicle(s) {
  if (s != undefined) {
    return s?.replaceAll('S.S.  ', '')?.replaceAll('“', '')?.replaceAll('”', '')
  } else {
    return ''
  }
}
class JobSummary extends Component {
  constructor(props) {
    super(props);
    this.state = {
      licenseID: '',
      history: [],
      arr: [],
      toggle: 'collapse multi-collapse',
      isLoading: true,
      approve: '',
      arrData: {},
      currentIndex: 0,
      finalIndex: 99,
      pairColor: {},
      riceTypeIDAndName: {},
      networkStatus: null,
      dupColor: {},
      checkWeightData: [],
    }
    this.renderCompany = this.renderCompany.bind(this)
  }


  componentDidMount() {

    let startViewRiceType = new Date()
    let viewAllSurveyRequestSheetByDatePromise = fetch(`https://backend1.riceinspections.com/testAA?timeValue=${this.props.location.state.timeValue || new Date()}`).then((res) => {return res.json()})
    let viewAllCheckWeightCompletePromise = axios.post('https://backend1.riceinspections.com/testHA',{data: { 'timeValue': this.props.location.state.timeValue || new Date() },}).then((res) => {return res['data']})
    let RequestComplete = fetch(`https://backend1.riceinspections.com/testA?timeValue=${this.props.location.state.timeValue}`).then((res) => {return res.json()})
    let RequestJobComplete = fetch('https://backend1.riceinspections.com/testB').then((res) => {return res.json()})
    let viewAllOfficer = fetch('https://backend1.riceinspections.com/testC').then((res) => {return res.json()})
    let viewAllCompany = fetch('https://backend1.riceinspections.com/testD').then((res) => {return res.json()})
    let viewAllRiceTypeIDAndNamePromise = fetch('https://backend1.riceinspections.com/testE').then((res) => {return res.json()})
 
    Promise.all([RequestComplete, RequestJobComplete, viewAllOfficer, viewAllCompany, viewAllRiceTypeIDAndNamePromise, viewAllSurveyRequestSheetByDatePromise, viewAllCheckWeightCompletePromise])
      .then((res) => {
        // console.log(new Date() - start)

        RequestComplete = res[0] || {}
        RequestJobComplete = res[1] || {}
        viewAllOfficer = res[2] || {}
        viewAllCompany = res[3] || {}
        viewAllRiceTypeIDAndNamePromise = res[4] || {}
        let viewAllSurveyRequestSheetByDate = res[5] || {}
        let viewAllCheckWeightComplete = res[6] || {}



        let dataForUpdate = updateState(RequestComplete, RequestJobComplete, viewAllOfficer, viewAllCompany)
        let newArr = dataForUpdate['0']
        let pairColor = dataForUpdate['2']
        let arr = evalSurveyRequest(viewAllSurveyRequestSheetByDate,RequestJobComplete)
        let newObjArr =  evalCheckWeight(viewAllCheckWeightComplete,arr)


        viewAllOfficer = Object.values(viewAllOfficer).sort((a, b) => parseInt(a.userName) - parseInt(b.userName))

        this.setState({
          ...this.state,
          RequestComplete: RequestComplete,
          RequestJobComplete: RequestJobComplete,
          viewAllOfficer: viewAllOfficer,
          arr: newArr,
          isLoading: false,
          viewAllCompany: viewAllCompany,
          pairColor: pairColor,
          riceTypeIDAndName: viewAllRiceTypeIDAndNamePromise,
          checkWeightData: arr
        })
      }).catch((err) => {
        this.setState({
          ...this.state,
          networkStatus: 'การเชื่อมต่ออินเทอร์เน็ตมีปัญหา'
        })
      })

  }
  




  


  renderDate(dateObj) {
    let dateParser = new Date(dateObj)
    let day = dateParser.getDate()
    let month = dateParser.getMonth() + 1
    let years = dateParser.getFullYear() + 543
    return `${day}/${month}/${years}`
  }
  renderCompany(companyObj) {
    // console.log(this.state.viewAllCompany)
    let viewAllCompany = this.state.viewAllCompany
    let outputCompany = null
    Object.values(viewAllCompany).map((companyData) => {
      if (companyData['companyNameTH'].replace(/\s/g, '').trim() == companyObj.replace(/\s/g, '').trim()) {
        outputCompany = companyData['companyNameEN']
      }
    })
    if (companyObj == 'ไทยฮาจำกัด') {
      outputCompany = 'THAI HA PUBLIC CO., LTD.'
    } else if (companyObj == 'ไทยฟ้า(2511)จำกัด') {
      outputCompany = 'THAI HUA (2511) CO., LTD.'
    }
    if (outputCompany) {
      return outputCompany
    } else {
      return companyObj
    }
  }

  handleSummit(riceTypeIDAndName) {
    //companyEN,godown,LoaingType,subID,licenseID,jobID,vehicleName,destinationCity,wtf1,TotalNett
    let arrWeight = []
    // data.map((o) => {
    //   o['description'].map((i, idx) => {
    //     // if(i['licenseID'] == '0308116549922'){
    //     //   console.log(o)
    //     // }
    //     // console.log(this.renderCompany(o['companyID']),o['godown'],i['LoaingType'],i['subID'],i['licenseID'],o['jobID'],i[`vehicleName${idx}`],i['destinationCity'],i['wtf'],i['quantity'])
    //     let a = { "0": { "trafficType": "1006.30.30-003", "des": "", "riceEN": "WhiteGlutinousRice10" }, "1": { "trafficType": "1006.20.90-607", "des": "", "riceEN": "BlackCargoRiceSuperbQuality" }, "2": { "trafficType": "1006.30.40-001", "des": "", "riceEN": "ThaiFragrantWhiteRice100" }, "3": { "trafficType": "1006.20.90-613", "des": "", "riceEN": "RedCargoRiceSuperbQuality" }, "4": { "trafficType": "1006.30.99-001", "des": "", "riceEN": "ThaiFragrantWhiteRice100" }, "5": { "trafficType": "1006.20.90-619", "des": "", "riceEN": "BlackGlutinousCargoRiceStandardQuality" }, "6": { "trafficType": "1006.20.90-608", "des": "", "riceEN": "BlackCargoRicePrimeQuality" }, "7": { "trafficType": "1006.20.90-614", "des": "", "riceEN": "RedCargoRicePrimeQuality" }, "8": { "trafficType": "1006.20.90-501", "des": "" }, "9": { "trafficType": "1006.20.90-001", "des": "", "riceEN": "ThaiFragrantCargoRice100" }, "10": { "trafficType": "1006.20.90-606", "des": "", "riceEN": "BlackCargoRicePrimeQuality" }, "11": { "trafficType": "1006.20.90-612", "des": "", "riceEN": "RedCargoRicePrimeQuality" }, "12": { "trafficType": "1006.30.91-002", "des": "" }, "13": { "trafficType": "1006.30.99-018", "des": "", "riceEN": "WhiteRice25" }, "14": { "trafficType": "1006.30.99-012", "des": "", "riceEN": "WhiteRice5" }, "15": { "trafficType": "1006.30.30-006", "des": "" }, "16": { "trafficType": "1006.30.99-007", "des": "" }, "17": { "trafficType": "1006.40.90-006", "des": "WhiteBrokenRiceA1Super","riceEN":"WhiteBrokenRiceA1Super" }, "18": { "trafficType": "1006.40.90-019", "des": "", "riceEN": "WhiteGlutinousBrokenRiceA1" }, "19": { "trafficType": "1006.40.90-602", "des": "", "riceEN": "WhiteGlutinousBrokenRiceAsPerSample" }, "20": { "trafficType": "1006.30.91-001", "des": "", "riceEN": "ParboiledRice100Sorted" }, "21": { "trafficType": "1006.30.91-600", "des": "", "riceEN": "ParboiledRiceAsPerSample" }, "22": { "trafficType": "1006.30.99-013", "des": "", "riceEN": "WhiteRice10" }, "23": { "trafficType": "1006.30.91-003", "des": "", "riceEN": "ParboiledRice5Sorted" }, "24": { "trafficType": "1006.40.90-005", "des": "", "riceEN": "ThaiFragrantWhiteBrokenRiceA1Super" }, "25": { "trafficType": "1006.20.90-018", "des": "", "riceEN": "CargoRice100GradeB" }, "26": { "trafficType": "1006.20.90-616", "des": "" }, "27": { "trafficType": "1006.30.99-010", "des": "", "riceEN": "WhiteRice100B" }, "28": { "trafficType": "1006.30.99-601", "des": "", "riceEN": "WhiteRiceAsPerSample" }, "29": { "trafficType": "1006.40.90-012", "des": "", "riceEN": "ThaiFragrantWhiteBrokenRiceA1Super" }, "30": { "trafficType": "1006.20.90-604", "des": "", "riceEN": "SpecialMixedCargoRiceAsPerSample" }, "31": { "trafficType": "1006.20.90-504", "des": "", "riceEN": "CargoRiceAsPerSample" }, "32": { "trafficType": "1006.20.90-615", "des": "", "riceEN": "RedCargoRiceSuperbQuality" }, "33": { "trafficType": "1006.40.90-010", "des": "", "riceEN": "ThaiFragrantWhiteBrokenRiceA1ExtraSuper" }, "34": { "trafficType": "1006.30.99-003", "des": "", "riceEN": "ThaiFragrantWhiteRice5" }, "35": { "trafficType": "1006.30.99-600", "des": "", "riceEN": "ThaiFragrantWhiteRiceAsPerSample" }, "36": { "trafficType": "1006.20.90-506", "des": "", "riceEN": "ThaiFragrantCargoRice100" }, "37": { "trafficType": "1006.20.90-633", "des": "", "riceEN": "BlackCargoRiceAsPerSample" }, "38": { "trafficType": "1006.30.99-014", "des": "", "riceEN": "WhiteRice15" }, "39": { "trafficType": "1006.20.90-600", "des": "", 'riceEN': 'CargoParboiledRiceAsPerSample' }, "40": { "trafficType": "1006.20.90-601", "des": "", "riceEN": "ThaiFragrantCargoRiceAsPerSample" }, "41": { "trafficType": "1006.30.99-603", "des": "", "riceEN": "SpecialMixedRiceAsPerSample" }, "42": { "trafficType": "1006.20.90-630", "des": "" }, "43": { "trafficType": "1006.20.90-618", "des": "", "riceEN": "BlackGlutinousCargoRiceBestQuality" }, "44": { "trafficType": "1006.40.90-018", "des": "", "riceEN": "ParboiledBrokenRiceA1" }, "45": { "trafficType": "1006.40.90-600", "des": "", "riceEN": "WhiteBrokenRiceC1AsPerSample" }, "46": { "trafficType": "1006.30.30-004", "des": "", "riceEN": "WhiteGlutinousRice10" }, "47": { "trafficType": "1006.40.90-001", "des": "", "riceEN": "CargoBrokenRiceAsPerSample" }, "48": { "trafficType": "1006.20.90-632", "des": "" }, "49": { "trafficType": "1006.30.91-007", "des": "", "riceEN": "ParboiledRice15" }, "50": { "trafficType": "1006.30.91-004", "des": "", "riceEN": "ParboiledRice5" }, "51": { "trafficType": "1006.20.90-010", "des": "", "riceEN": "CargoRice5" }, "52": { "trafficType": "1006.30.99-009", "des": "", "riceEN": "WhiteRice100A" }, "53": { "trafficType": "1006.20.90-609", "des": "", "riceEN": "BlackCargoRiceSuperbQuality" }, "54": { "trafficType": "1006.30.99-015", "des": "" }, "55": { "trafficType": "1006.30.99-502", "des": "", "riceEN": "ThaiFragrantWhiteRice100" }, "56": { "trafficType": "1006.30.40-500", "des": "", "riceEN": "ThaiFragrantWhiteRice100" }, "57": { "trafficType": "1006.40.90-004", "des": "", "riceEN": "WhiteBrokenRiceA1ExtraSuper" }, "58": { "trafficType": "1006.30.99-602", "des": "", "riceEN": "WhiteRiceAsPerSample" }, "59": { "trafficType": "1006.20.90-610", "des": "", "riceEN": "BlackCargoRiceAsPerSample" }, "60": { "trafficType": "1006.20.90-622", "des": "", "riceEN": 'BlackGlutinousCargoRiceAsPerSample' }, "61": { "trafficType": "1006.20.90-631", "des": "" }, "62": { "trafficType": "1006.20.90-605", "des": "", "riceEN": "RedCargoRiceSuperbQuality" }, "63": { "trafficType": "1006.30.30-601", "des": "","riceEN" : "SPECIALMIXEDGLUTINOUSRICEASPERSAMPLE" }, "64": { "trafficType": "1006.30.99-023", "des": "", "riceEN": "WhiteRiceEnrichedVitaminAsPerSample" }, "65": { "trafficType": "1006.30.40-006", "des": "", "riceEN": "ThaiFragrantWhiteRice15" }, "66": { "trafficType": "1006.40.90-003", "des": "" }, "67": { "trafficType": "1006.30.99-022", "des": "", "riceEN": "WhiteRice45" }, "68": { "trafficType": "1006.30.99-011", "des": "", "riceEN": "WhiteRice100C" }, "69": { "trafficType": "1006.30.99-005", "des": "" }, "70": { "trafficType": "1006.20.90-011", "des": "", "riceEN": "CargoRice10" }, "71": { "trafficType": "1006.40.90-609", "des": "" }, "72": { "trafficType": "1006.20.90-012", "des": "" }, "73": { "trafficType": "1006.20.90-508", "des": "" }, "74": { "trafficType": "1006.20.90-611", "des": "" }, "75": { "trafficType": "1006.20.90-617", "des": "" }, "76": { "trafficType": "1006.20.90-620", "des": "", "riceEN": "BlackGlutinousCargoRiceBestQuality" } }


    //     let riceTH = convertRiceTypeTHToEN(i['riceTypeName'], riceTypeIDAndName)
    //     console.log(riceTH)
    //     Object.values(a).map((riceObj) => {
    //       if (riceObj['trafficType'] == riceTH) {
    //         console.log(riceTH, riceObj['riceEN'])
    //         riceTH = riceObj['riceEN']
    //       }
    //     })
    //     console.log(riceTH,o)
    //     riceTH = riceTH.toUpperCase()

    //     let filtered_parboiled = riceTH.indexOf('PARBOILED') == -1 ? false : true

    //     // console.log()
    //     if (filtered_parboiled == false && Number.isFinite(i['quantity'])) {
    //       arrWeight.push({
    //         'companyEN': this.renderCompany(o['companyID']),
    //         'godown': o['godown'],
    //         'checkWeight': {
    //           'LoaingType': i['LoaingType'],
    //         },
    //         'subID': i['subID'],
    //         'licenseID': i['licenseID'],
    //         'jobID': o['jobID'],
    //         'vehicleName': i[`vehicleName${idx}`],
    //         'destinationCity': i['destinationCity'],
    //         'wtf1': riceTH,
    //         'TotalNett': `${((Math.round((i['quantity']) * 100)) / 100) * 1000}`,
    //       })
    //     }
    //   })
    // })


    // let ranked_by_license = arrWeight
    // let startDate = '01/01/2020'

    // exportExcelNew(ranked_by_license, remove_double_spacing, remove_go_down, modifier_license_length, modifier_loading, modifier_vehicle, startDate)
  }
  render() {
    if (!this.state.isLoading) {
      return (
        <Container>
          <AdminNav></AdminNav>
          <Navbar style={{ backgroundColor: '#F5F5F5', zIndex: '0' }} sticky="top" >
            <Container style={{ zIndex: '0' }} >
              <Navbar.Brand></Navbar.Brand>
              <p><b>สรุปยอดส่วนจ่ายงานและCheckweight ประจำวันที่ {this.renderDate(this.props.location.state.timeValue || new Date())}</b></p>
              <Navbar.Brand></Navbar.Brand>
            </Container>
          </Navbar>


          <Button onClick={() => { this.handleSummit(this.state.riceTypeIDAndName) }} > Printout</Button>



        </Container>
      )
    }
    else if (this.state.networkStatus) {
      return (<Container>
        <AdminNav></AdminNav>
        <Loading title={this.state.networkStatus} />
      </Container>)
    }
    else {
      return (<Container>
        <AdminNav></AdminNav>
        <Loading title={(() => {
          if (this.state.currentIndex == 0) {
            return null
          } else {
            return `สำเร็จแล้ว ${this.state.currentIndex}/${this.state.finalIndex} รายการ`
          }
        })()} />
      </Container>)
    }
  }
}



export default JobSummary;
